import { Box, Stack, Typography } from "@mui/material";
import moment from "moment";

// const InsightDropdown = ({ expandedValues }) => (
//   <TooltipLight
//     title={
//       <Box>
//         {expandedValues.map((row) => (
//           <Typography>
//             {row.displayValue} {row.changeType} {row.percentageChange}%
//           </Typography>
//         ))}
//       </Box>
//     }
//   >
//     <ArrowDropDown
//       sx={{
//         ml: "-3px",
//       }}
//     />
//   </TooltipLight>
// );

const Insight = ({ user, insight }) => {
  // const types = ["Weekly", "Daily", "Monthly"];
  // const randomRef = useRef(Math.floor(Math.random() * types.length));
  // const type = types[randomRef.current];

  const renderIcon = () => {
    let icon = "W";
    let bgcolor = "#4949a2";
    switch (insight.interval) {
      case "Weekly":
        icon = "W";
        bgcolor = "#4949a2";
        break;
      case "Daily":
        icon = "D";
        bgcolor = "#4990a2";
        break;
      case "Monthly":
        icon = "M";
        bgcolor = "#a26c49";
        break;
      default:
        break;
    }
    return (
      <Box className="icon-box" sx={{ backgroundColor: `${bgcolor} !important` }}>
        <Typography sx={{ color: "#fff" }}>{icon}</Typography>
      </Box>
    );
  };

  return (
    <Box className="insight-wrapper">
      <Stack direction="row" sx={{ width: "100%" }}>
        {renderIcon()}
        <Stack flexGrow={1}>
          <Stack direction="row" alignItems="center">
            <Typography
              sx={{ fontWeight: 700, fontSize: "1rem" }}
            >{`${insight.interval} Insight`}</Typography>
            <Typography sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#888", ml: "0.5rem" }}>
              {moment.tz(insight.createdAt, user.timezone).format("M/D/YYYY h:mma")}
            </Typography>
          </Stack>
          <Box>
            <Typography sx={{ fontSize: "1rem" }}>{insight.displayMessage}</Typography>
          </Box>
        </Stack>
      </Stack>
    </Box>
    // <>
    //   <TableCell>
    //     <Box>
    //       {insight.displayMessage}
    //       {insight?.expandedValues?.length > 0 && (
    //         <InsightDropdown expandedValues={insight.expandedValues} />
    //       )}
    //     </Box>
    //   </TableCell>
    //   <TableCell>
    //     {insight.currentStatus}
    //     {insight.muted ? (
    //       <NotificationsOff
    //         sx={{
    //           ml: "0.5rem",
    //           color: "#666",
    //           cursor: "pointer",
    //         }}
    //         onClick={handleMute}
    //       />
    //     ) : (
    //       <Notifications
    //         sx={{
    //           ml: "0.5rem",
    //           color: "#666",
    //           cursor: "pointer",
    //         }}
    //         onClick={handleMute}
    //       />
    //     )}
    //   </TableCell>
    // </>
  );
};

export default Insight;
